import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "base-form header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Запчасти", -1)
const _hoisted_3 = {
  class: "base-form",
  style: {"width":"100%!important","max-width":"unset","display":"block"}
}
const _hoisted_4 = { style: {"margin":"1rem 0 0 0"} }
const _hoisted_5 = { class: "base-form filter" }
const _hoisted_6 = { class: "base-form filter" }
const _hoisted_7 = { class: "base-form filter" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _createVNode(_component_el_button, {
                type: "primary",
                icon: _ctx.circleIcon,
                size: "large",
                onClick: _ctx.onAddItemClick
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Новая запчасть ")
                ]),
                _: 1
              }, 8, ["icon", "onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.isDictionaryModeEnabled)
      ? (_openBlock(), _createBlock(_component_el_row, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 24,
              style: {"text-align":"left"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_el_space, {
                    fill: "",
                    style: {"width":"80%","min-width":"350px","max-width":"800px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_card, { fill: "" }, {
                        header: _withCtx(() => [
                          _createVNode(_component_el_text, {
                            type: "primary",
                            size: "large"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Выбранные запчасти "),
                              _createVNode(_component_el_tag, {
                                type: "primary",
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.selectedItems.length), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            style: {"width":"100%"},
                            modelValue: _ctx.selectedItems,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedItems) = $event)),
                            multiple: "",
                            clearable: "",
                            placeholder: "Запчасти"
                          }, {
                            label: _withCtx(({ value }) => [
                              _createTextVNode(_toDisplayString(_ctx.formatSelectedItem(value)), 1)
                            ]),
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableSelectedItems, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  label: item.externalName,
                                  value: item.id
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", null, _toDisplayString(item.externalName) + ", " + _toDisplayString(item.partNumber), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _ctx.onSaveItemsSetClick
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Сохранить")
                              ]),
                              _: 1
                            }, 8, ["onClick"]),
                            _createVNode(_component_el_button, { onClick: _ctx.onClearItemsSetClick }, {
                              default: _withCtx(() => [
                                _createTextVNode("Очистить")
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 6 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_input, {
                modelValue: _ctx.tableSearchQuery,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tableSearchQuery) = $event)),
                style: {"max-width":"600px"},
                placeholder: "Поиск по артикулу, названию, группе и производителю",
                class: "input-with-select"
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_el_button, { icon: _ctx.searchIcon }, null, 8, ["icon"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 6 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_select, {
                modelValue: _ctx.tableGroupsFilter,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tableGroupsFilter) = $event)),
                multiple: "",
                placeholder: "Фильтр по группам"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemGroups, (e) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: e.id,
                      value: e.id,
                      label: e.name
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 6 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_select, {
                modelValue: _ctx.tableManufacturersFilter,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tableManufacturersFilter) = $event)),
                multiple: "",
                placeholder: "Фильтр по производителям"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemManufacturers, (e) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: e.id,
                      value: e.id,
                      label: e.name
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              ref: "tableRef",
              "row-key": "id",
              "element-loading-svg": _ctx.tableLoadingSvg,
              onSortChange: _ctx.onTableSortingChange,
              onRowClick: _ctx.onTableRowClick,
              data: _ctx.tableData,
              "default-sort": { prop: _ctx.tableSortColumn, order: _ctx.tableSortOrder }
            }, {
              default: _withCtx(() => [
                (!_ctx.isDictionaryModeEnabled)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 0,
                      type: "selection"
                    }))
                  : _createCommentVNode("", true),
                (_ctx.isDictionaryModeEnabled)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 1,
                      width: "45"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_checkbox, {
                          value: scope.row.id,
                          onChange: (state) => _ctx.onItemSelectChange(state, scope.row.id)
                        }, null, 8, ["value", "onChange"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_table_column, {
                  label: "Артикул",
                  sortable: "",
                  prop: "partNumber",
                  "column-key": "partNumber"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Наименование",
                  sortable: "",
                  prop: "externalName",
                  "column-key": "partNumber"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Производитель",
                  sortable: "",
                  prop: "manufacturer.name",
                  "column-key": "manufacturer"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Единица измерения",
                  prop: "measureUnit.name",
                  "column-key": "measureUnit"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Группа",
                  prop: "group.name",
                  sortable: "",
                  "column-key": "group"
                }),
                _createVNode(_component_el_table_column, {
                  width: "74",
                  align: "right"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_button, {
                      icon: _ctx.deleteIcon,
                      type: "danger",
                      circle: "",
                      onClick: (e) => _ctx.onDeleteItemClick(e, scope.row)
                    }, null, 8, ["icon", "onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["element-loading-svg", "onSortChange", "onRowClick", "data", "default-sort"])), [
              [_directive_loading, _ctx.tableLoading]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}